import { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {
  FormControl,
  Grid,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
} from '@mui/material';
import PageLayout from '../../../../Containers/PageLayout';
import { ROUTES } from '../../../../helpers/contants';
import { useListing } from '../../../../hooks/useListing';
import endPoints from '../../../../api/endpoint';
import '../../../RiskCenter/service.scss';
import {
  setRiskBreadCrumbs,
  updatePaginationPage,
} from '../../../../redux/commonSlice';
import HeadingRow from '../../../Dashboard/components/HeadingRow';
import AddButton from '../../../../Components/AddButton';
import NoData from '../../../../Components/Nodata';
import {
  TabProps,
  formatStringToTitleCase,
  useDebounce,
  getTimeWithTimeZoneAbbreviationNew,
} from '../../../../Utils/helperFns';
import Images from '../../../../Utils/images';
import ThreatCard from '../ThreatCard';
import '../../RiskCenter.scss';
import InfiniteScroll from '../../../../Components/InfiniteScrollComponent';
import TableLoader from '../../../Dashboard/components/SkeletonLoader/TableLoader';
import AutocompleteSelect from '../../../../Components/AutocompleteSelect';
import ToolTipComponent from '../../../../Components/ToolTipComponent';
import RiskCardLoader from '../RiskCardLoader';
import TablePagination from '../../../../Components/Pagination';
import MUIAutoComplete from '../../../../Components/MUIAutoComplete';
import dayjs from 'dayjs';

const ViewAllProductionSets = () => {
  const [value, setValue] = useState(0);
  const { productionId, name } = useParams();
  const navigate = useNavigate();
  const [serachParams] = useSearchParams();
  const productionType = serachParams.get('productionType');
  const productionName = serachParams.get('productionName');
  const studioId = serachParams.get('studioId');

  const [searchKey, setSearchKey] = useState<string>('');
  const [tabCounts, setTabCounts] = useState<any>(null);
  const [isTabular, setIsTabular] = useState<boolean>(false);
  const [threatFilter, setThreatFilter] = useState<string | null>('ALL');
  const [filter, setFilter] = useState<any>({
    page: 1,
    limit: 8,
    searchKey: '',
    riskLevel: '',
    setId: '',
    episodeId: '',
  });
  const [searchInput, setSearchInput] = useState('');
  const debouncedSearch = useDebounce(searchInput, 500);

  const [dropdownfilter, setDropdownFilter] = useState<any>({
    page: 1,
    limit: 10,
    searchKey: '',
  });

  const {
    fetchListing,
    data: productionSetList,
    hasMore,
    loading,
    setData,
    count,
  } = useListing<any>({
    url: endPoints.riskSecurity.productionDashboardSetThreats.replace(
      '{productionId}',
      productionId || '',
    ),
    params: {
      ...filter,
      search: filter.search || '',
      setStatus:
        value === 0
          ? 'ACTIVE'
          : value === 1
          ? 'COMPLETED'
          : value === 2
          ? 'INACTIVE'
          : 'ALL',
      riskLevel: filter.riskLevel || '',
    },
    isInfinite: !isTabular,
    isRiskDashboard: true,
    setCountData: setTabCounts,
  });

  const {
    fetchListing: fetchSetEpisodeListingDropdown,
    data: setEpisodeDropdownList,
    hasMore: hasMoreSetEpisode,
    loading: loadingSetEpisode,
  } = useListing<any>({
    url: endPoints.riskSecurity.productionDashboardSetThreats.replace(
      '{productionId}',
      productionId || '',
    ),
    params: {
      ...dropdownfilter,
      // search: filter.search || '',
    },
    isInfinite: !isTabular,
    isRiskDashboard: true,
    setCountData: setTabCounts,
  });

  useEffect(() => {
    if (filter.page === 1) setData([]);
    fetchListing();
  }, [filter, value]);

  const loadMore = () => {
    if (!loading && hasMore) {
      setFilter({
        ...filter,
        page: filter.page + 1,
      });
    }
  };

  useEffect(() => {
    updatePaginationPage(1);
  }, []);

  useEffect(() => {
    fetchSetEpisodeListingDropdown();
  }, [dropdownfilter]);

  const showBreadCrumb = () => {
    return (
      <>
        <ul className="breadCrumbs">
          <li>
            <a href={`${ROUTES.RISK_CENTER}?${productionId}`}>
              {productionName || 'Production Dashboard'}
            </a>
          </li>
          <li>{`Threat Level By ${
            productionType === 'TV Series' ||
            productionType === 'Multiple Live Events'
              ? productionType === 'Multiple Live Events'
                ? 'Event'
                : 'Episode'
              : productionType?.toLowerCase()?.includes('event')
              ? 'Activity'
              : 'Set'
          }`}</li>
        </ul>
      </>
    );
  };

  const filterOptions = [
    { id: '', label: 'All' },
    { id: 'CRITICAL', label: 'Critical' },
    { id: 'HIGH', label: 'High' },
    { id: 'MEDIUM', label: 'Medium' },
    { id: 'LOW', label: 'Low' },
  ];
  const ALL_OPTION = { label: 'All', value: 'ALL' };

  useEffect(() => {
    setDropdownFilter(prev => ({
      ...prev,
      page: 1, // 🔥 reset pagination on search
      searchKey: debouncedSearch,
    }));
  }, [debouncedSearch]);

  return (
    <PageLayout>
      <section className="store-inner">
        <HeadingRow
          title={`Threat Level By ${
            productionType === 'TV Series' ||
            productionType === 'Multiple Live Events'
              ? productionType === 'Multiple Live Events'
                ? 'Event'
                : 'Episode'
              : productionType?.toLowerCase()?.includes('event')
              ? 'Activity'
              : 'Set'
          }`}
          setData={setData}
          onSearch={(value: string) => {
            setFilter({
              ...filter,
              searchKey: value.trim(),
              page: 1,
            });
          }}
          handleClearSearch={() => {
            updatePaginationPage(1);
            setData([]);
            setThreatFilter('ALL');
            setFilter({
              ...filter,
              searchKey: '',
              page: 1,
            });
          }}
          isTabular={isTabular}
          setIsTabular={setIsTabular}
          setFilter={() => {
            setData([]);
            setFilter({
              ...filter,
              page: 1,
              searchKey: '',
            });
          }}
          isManage
          isShowViewBtn={count > 0}
          searchKey={searchKey}
          setSearchKey={setSearchKey}
          showBreadCrumb={showBreadCrumb}
          isShowBreadcrumb
          searchPlaceholder={`Search ${
            productionType === 'TV Series' ||
            productionType === 'Multiple Live Events'
              ? productionType === 'Multiple Live Events'
                ? 'Event'
                : 'Episode'
              : productionType?.toLowerCase()?.includes('event')
              ? 'Activity'
              : 'Set'
          }...`}
          productionId={productionId}
          studioName={name}
        />

        <div className="left">
          <Grid container spacing={1}>
            <Grid item md={4} xs={12}>
              <div className="form-in lg">
                <MUIAutoComplete
                  name="studio"
                  id={'studio'}
                  type="riskStudio"
                  keyName="name"
                  options={[
                    ALL_OPTION, // ✅ default All option
                    ...(setEpisodeDropdownList && setEpisodeDropdownList?.length
                      ? setEpisodeDropdownList?.map((item: any) => ({
                          label:
                            productionType === 'TV Series' ||
                            productionType === 'Multiple Live Events'
                              ? `${
                                  item?.episodeNumber
                                    ? item?.episodeNumber + ' - '
                                    : ''
                                }${item?.name}`
                              : item?.name,
                          value: item?._id,
                        }))
                      : []),
                  ]}
                  limit={2}
                  setValue={setValue}
                  clearIcon
                  defaultValue={ALL_OPTION}
                  placeHolderText={'Select Production'}
                  addOptionText={'Create new Studio/Prod Co.'}
                  isScroll={true}
                  fetchMoreOptions={() => {
                    if (!loadingSetEpisode && hasMoreSetEpisode) {
                      setDropdownFilter({
                        ...dropdownfilter,
                        page: dropdownfilter.page + 1,
                      });
                    }
                  }}
                  onInputChange={(
                    event: any,
                    value: string,
                    reason: string,
                  ) => {
                    // ✅ ONLY when user types
                    if (reason !== 'input') return;

                    // ✅ Ignore default "All"
                    if (value === ALL_OPTION.label) return;

                    setSearchInput(value);
                  }}
                  hasMoreOptions={true}
                  isEvent
                  onChangeMethod={(option: any) => {
                    setData([]); // 🔥 reset list
                    if (
                      productionType === 'TV Series' ||
                      productionType === 'Multiple Live Events'
                    ) {
                      setFilter(prev => ({
                        ...prev,
                        page: 1,
                        episodeId: option?.value === 'ALL' ? '' : option?.value,
                      }));
                    } else {
                      setFilter(prev => ({
                        ...prev,
                        page: 1,
                        setId: option?.value === 'ALL' ? '' : option?.value,
                      }));
                    }
                  }}
                  dropdownLoading={loadingSetEpisode}
                />
              </div>
            </Grid>
            <Grid item md={4} xs={12}>
              <div className="form-in lg">
                <FormControl fullWidth>
                  <div className="f-in">
                    <AutocompleteSelect
                      id="ThreatFilter"
                      labelKey="label"
                      placeHolderText="Threat Level"
                      options={filterOptions}
                      value={
                        filterOptions.find(o => o.id === filter.riskLevel) ??
                        filterOptions[0]
                      }
                      onChange={(event: any, option: any) => {
                        const selected = option?.id ?? 'ALL';
                        setThreatFilter(selected);
                        setFilter(prev => ({
                          ...prev,
                          page: 1,
                          riskLevel: selected,
                        }));
                      }}
                    />
                  </div>
                </FormControl>
              </div>
            </Grid>
          </Grid>
        </div>

        <AddButton />
        <Tabs
          value={value}
          onChange={(e, newVal) => {
            setValue(newVal);
            setData([]);
            setFilter({
              ...filter,
              page: 1,
            });
          }}
          variant="scrollable"
          centered
          scrollButtons={false}
          className="mb-24"
        >
          <Tab
            label={`Active (${
              productionType === 'TV Series' ||
              productionType === 'Multiple Live Events'
                ? tabCounts?.activeEpisode || 0
                : tabCounts?.activeSet || 0
            })`}
            {...TabProps(0)}
          />
          <Tab
            label={`Completed (${
              productionType === 'TV Series' ||
              productionType === 'Multiple Live Events'
                ? tabCounts?.completedEpisode || 0
                : tabCounts?.completedSet || 0
            })`}
            {...TabProps(1)}
          />
          <Tab
            label={`Upcoming (${
              productionType === 'TV Series' ||
              productionType === 'Multiple Live Events'
                ? tabCounts?.inactiveEpisode || 0
                : tabCounts?.inactiveSet || 0
            })`}
            {...TabProps(2)}
          />

          <Tab
            label={`All (${
              productionType === 'TV Series' ||
              productionType === 'Multiple Live Events'
                ? tabCounts?.allEpisode || 0
                : tabCounts?.allSet || 0
            })`}
            {...TabProps(3)}
          />
        </Tabs>

        {/* VIEW: TABLE OR GRID */}
        {loading && filter.page === 1 && !isTabular ? (
          <RiskCardLoader />
        ) : loading && filter.page === 1 ? (
          <TableLoader />
        ) : !isTabular ? (
          productionSetList?.length ? (
            <InfiniteScroll
              isLoading={loading && filter.page > 1}
              noData={!loading && !productionSetList.length}
              hasMore={hasMore}
              onLoadMore={loadMore}
              className="with-title"
              isShowNoData
              loadingComponent={<RiskCardLoader />}
              noDataText={`No ${
                productionType === 'TV Series' ||
                productionType === 'Multiple Live Events'
                  ? productionType === 'Multiple Live Events'
                    ? 'Events'
                    : 'Episodes'
                  : productionType?.toLowerCase()?.includes('event')
                  ? 'Activities'
                  : 'Sets'
              } Found`}
              title={`No ${
                productionType === 'TV Series' ||
                productionType === 'Multiple Live Events'
                  ? productionType === 'Multiple Live Events'
                    ? 'Events'
                    : 'Episodes'
                  : productionType?.toLowerCase()?.includes('event')
                  ? 'Activities'
                  : 'Sets'
              } belong to this studio.`}
            >
              <Grid container spacing={2} className="flex-height">
                {productionSetList?.map((item: any) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
                    <ThreatCard
                      iconClassName="urgent-icon"
                      data={item}
                      productionType={productionType || ''}
                      isProduction={true}
                      studioId={studioId}
                    />
                  </Grid>
                ))}
              </Grid>
            </InfiniteScroll>
          ) : (
            <NoData
              title={`No ${
                productionType === 'TV Series' ||
                productionType === 'Multiple Live Events'
                  ? productionType === 'Multiple Live Events'
                    ? 'Events'
                    : 'Episodes'
                  : productionType?.toLowerCase()?.includes('event')
                  ? 'Activities'
                  : 'Sets'
              } Found`}
            />
          )
        ) : productionSetList && productionSetList?.length ? (
          <TableContainer className="reelTable table_height sm-table">
            <Table stickyHeader aria-label="table" className="reelTable">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {productionType === 'TV Series' ||
                    productionType === 'Multiple Live Events'
                      ? productionType === 'Multiple Live Events'
                        ? 'Events'
                        : 'Episodes'
                      : productionType?.toLowerCase()?.includes('event')
                      ? 'Activities'
                      : 'Sets'}
                  </TableCell>
                  <TableCell align="left">Threat Level</TableCell>
                  <TableCell align="left">Threat Type</TableCell>
                  <TableCell align="center">Action Items</TableCell>
                  <TableCell align="left">Updated</TableCell>
                  <TableCell align="center">Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(productionSetList?.length > 4
                  ? productionSetList?.slice(0, 8)
                  : productionSetList
                ).map((item: any) => {
                  const { image, name, locationCount, fallbackImage } = item;

                  const imageUrl =
                    image?.startsWith('http') || image?.startsWith('https')
                      ? image
                      : fallbackImage || Images.VENDOR_PLACEHOLDER;

                  return (
                    <TableRow key={item._id}>
                      <TableCell align="left" sx={{ cursor: 'pointer' }}>
                        <div className="d-flex align-center table-name">
                          <img
                            src={imageUrl}
                            alt={name}
                            className="table-thumb mr-8"
                            onError={e => {
                              e.target.src = Images.VENDOR_PLACEHOLDER;
                            }}
                          />
                          <div>
                            <p className="mb-4">
                              {' '}
                              {productionType === 'TV Series' ||
                              productionType === 'Multiple Live Events'
                                ? `${
                                    item?.episodeNumber
                                      ? item?.episodeNumber + ' - '
                                      : ''
                                  }${name}`
                                : name.toUpperCase()}
                            </p>

                            <div className="chips shrink border">
                              <span className="blue">
                                {formatStringToTitleCase(item?.type)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </TableCell>

                      {/* Threat Level Column */}
                      <TableCell align="left">
                        <div className="chips shrink border">
                          {(() => {
                            const levels = item?.threatLevels || [];
                            if (!levels.length) return '-';

                            const first = levels[0];
                            const others = levels.slice(1);

                            return (
                              <>
                                {/* FIRST CHIP (same UI as card) */}
                                <span
                                  className={
                                    first?.level === 'CRITICAL'
                                      ? 'red'
                                      : first?.level === 'HIGH'
                                      ? 'orange'
                                      : first?.level === 'MEDIUM'
                                      ? 'yellow'
                                      : first?.level === 'LOW'
                                      ? 'green'
                                      : ''
                                  }
                                >
                                  <i
                                    className={
                                      first?.level === 'CRITICAL'
                                        ? 'urgent-icon'
                                        : first?.level === 'HIGH'
                                        ? 'urgent-icon'
                                        : first?.level === 'MEDIUM'
                                        ? 'medium-icon'
                                        : first?.level === 'LOW'
                                        ? 'low-icon'
                                        : ''
                                    }
                                  ></i>{' '}
                                  {first?.count}{' '}
                                  {formatStringToTitleCase(first?.level)}
                                </span>

                                {/* Tooltip Trigger */}
                                {others.length > 0 && (
                                  <ToolTipComponent
                                    theme="light"
                                    arrow
                                    title={
                                      <div>
                                        {others.map((lvl: any, i: number) => (
                                          <p key={i}>
                                            {lvl?.count}{' '}
                                            {formatStringToTitleCase(
                                              lvl?.level,
                                            )}
                                          </p>
                                        ))}
                                      </div>
                                    }
                                  >
                                    <span className="blue">
                                      +{others.length}
                                    </span>
                                  </ToolTipComponent>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </TableCell>

                      {/* Threat Type Column */}
                      <TableCell align="left">
                        <div className="chips shrink border">
                          {(() => {
                            const types = item?.threatTypes || [];
                            if (!types.length) return '-';

                            const first = types[0];
                            const others = types.slice(1);

                            const maxLength = 24;
                            const truncate = (txt: string) =>
                              txt?.length > maxLength
                                ? txt.slice(0, maxLength) + '...'
                                : txt;

                            return (
                              <>
                                {/* FIRST TRUNCATED CHIP (same UI as card) */}
                                <span className="yellow">
                                  {formatStringToTitleCase(
                                    truncate(first?.type),
                                  )}
                                </span>

                                {/* Tooltip trigger */}
                                {others.length > 0 && (
                                  <ToolTipComponent
                                    theme="light"
                                    arrow
                                    title={
                                      <div>
                                        {others.map((t: any, i: number) => (
                                          <p key={i}>
                                            {formatStringToTitleCase(t?.type)}
                                          </p>
                                        ))}
                                      </div>
                                    }
                                  >
                                    <span className="blue">
                                      +{others.length}
                                    </span>
                                  </ToolTipComponent>
                                )}
                              </>
                            );
                          })()}
                        </div>
                      </TableCell>

                      <TableCell align="center" width={'80px'}>
                        {item?.actionItems?.total > 0
                          ? item?.actionItems?.display
                          : '-'}
                      </TableCell>

                      <TableCell align="left" width={'130px'}>
                        {item?.locationCount > 0 ? (
                          <p>
                            Updated on{' '}
                            {`${dayjs(item?.updatedAt).format(
                              'MMM D, YYYY h:mm A',
                            )} ${getTimeWithTimeZoneAbbreviationNew(
                              item?.updatedAt,
                              'z',
                            )}`}
                          </p>
                        ) : (
                          '-'
                        )}
                      </TableCell>

                      <TableCell align="center" width={'120px'}>
                        <button
                          className="blank-btn text-linking underline MuiTypography-subtitle1"
                          onClick={() => {
                            if (
                              productionType === 'TV Series' ||
                              productionType === 'Multiple Live Events'
                            ) {
                              const episode = studioId
                                ? [
                                    {
                                      name: 'episode',
                                      type: 'episode risk dashboard',
                                      title: `${
                                        item?.episodeNumber
                                          ? item?.episodeNumber + ' - '
                                          : ''
                                      }${item?.name}`,
                                      path: `${
                                        ROUTES.EPIOSDE_SECURITY_DASHBOARD
                                      }?episodeId=${item?._id}&name=${
                                        item?.episodeNumber
                                          ? item?.episodeNumber + ' - '
                                          : ''
                                      }${item?.name}&studioId=${studioId}`,
                                    },
                                  ]
                                : [
                                    {
                                      name: 'episode',
                                      type: 'episode risk dashboard',
                                      title: `${
                                        item?.episodeNumber
                                          ? item?.episodeNumber + ' - '
                                          : ''
                                      }${item?.name}`,
                                      path: `${
                                        ROUTES.EPIOSDE_SECURITY_DASHBOARD
                                      }?episodeId=${item?._id}&name=${
                                        item?.episodeNumber
                                          ? item?.episodeNumber + ' - '
                                          : ''
                                      }${item?.name}`,
                                    },
                                  ];
                              setRiskBreadCrumbs(episode);

                              if (studioId) {
                                navigate(
                                  `/episode-security-dashboard?episodeId=${
                                    item._id
                                  }&name=${
                                    item?.episodeNumber
                                      ? item?.episodeNumber + ' - '
                                      : ''
                                  }${item?.name}&studioId=${studioId}`,
                                );
                              } else {
                                navigate(
                                  `/episode-security-dashboard?episodeId=${
                                    item._id
                                  }&name=${
                                    item?.episodeNumber
                                      ? item?.episodeNumber + ' - '
                                      : ''
                                  }${item?.name}`,
                                );
                              }
                            } else {
                              if (studioId) {
                                const set = studioId
                                  ? [
                                      {
                                        name: 'set',
                                        type: 'set risk dashboard',
                                        title: `${item?.name?.toUpperCase()}`,
                                        path: `${
                                          ROUTES.SET_SECURITY_DASHBOARD
                                        }?setId=${
                                          item?._id
                                        }&name=${item?.name?.toUpperCase()}&studioId=${studioId}`,
                                      },
                                    ]
                                  : [
                                      {
                                        name: 'set',
                                        type: 'set risk dashboard',
                                        title: `${item?.name?.toUpperCase()}`,
                                        path: `${
                                          ROUTES.SET_SECURITY_DASHBOARD
                                        }?setId=${
                                          item?._id
                                        }&name=${item?.name?.toUpperCase()}`,
                                      },
                                    ];
                                setRiskBreadCrumbs(set);
                                navigate(
                                  `/set-security-dashboard?setId=${
                                    item._id
                                  }&name=${item?.name?.toUpperCase()}&studioId=${studioId}`,
                                );
                              } else {
                                navigate(
                                  `/set-security-dashboard?setId=${
                                    item._id
                                  }&name=${item?.name?.toUpperCase()}`,
                                );
                              }
                            }
                          }}
                        >
                          View Details
                        </button>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>

            {productionSetList?.length && count > 8 && (
              <TablePagination
                limit={8}
                totalRecords={count}
                listData={productionSetList}
                setPageChange={(val: number) => {
                  updatePaginationPage(val);
                  setFilter({ ...filter, page: val });
                }}
              />
            )}
          </TableContainer>
        ) : (
          <NoData
            title={`No ${
              productionType === 'TV Series' ||
              productionType === 'Multiple Live Events'
                ? productionType === 'Multiple Live Events'
                  ? 'Event'
                  : 'Episode'
                : productionType?.toLowerCase()?.includes('event')
                ? 'Activity'
                : 'Set'
            } Found`}
          />
        )}
      </section>
    </PageLayout>
  );
};

export default ViewAllProductionSets;
